export const GSMA_NSX_FEATURE_FLAG = 'gsma_nsx';

export const GSMA_NSX_PORTAL_URL =
  'https://www.gsmaservices.com/network-services/network-settings-exchange/';

export const GSMA_NSX_DOCS_ROUTE = '/developers?tab=gsma-nsx';
